import { useEffect } from 'react'
import { useLocation } from 'react-router'
import { resolveCohort } from 'nove8/helpers/resolveCohort'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useSetInitialCohort = (): void => {
  const { search } = useLocation()
  const firebaseRemoteConfig = useZustandStore(
    (state) => state.firebaseRemoteConfig,
  )

  useEffect(() => {
    const URLParams = new URLSearchParams(search)
    const cohortFromUrl = URLParams.get('cohort') || ''
    const cohort = resolveCohort(cohortFromUrl)

    useZustandStore.setState({ initialCohort: cohort })
    useZustandGlobalLocalStore.setState((state) => ({
      previousCohort: state.previousCohort || cohort,
    }))
  }, [firebaseRemoteConfig])
}
